import { render, staticRenderFns } from "./leagueLogInfo.vue?vue&type=template&id=0586cd06&scoped=true&lang=pug&"
import script from "./leagueLogInfo.vue?vue&type=script&lang=js&"
export * from "./leagueLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586cd06",
  null
  
)

export default component.exports